import { useSelector } from "react-redux"
import { RootState } from "../store/store"

const Lang = (key?: string) => {
    const result = useSelector((state: RootState) => state.lang.dict)
    const obj = result ? JSON.parse(JSON.stringify(result)) : {}
    return obj && key ? obj[key] : (obj ?? 'N/A')
}

export default Lang